import Moment from 'moment';
export function FormatDateTime(dateTime) {
  Moment.locale('sv-Se');
  return dateTime == null ? '' : Moment.utc(dateTime).format('YYYY-MM-DD HH:mm:ss');
}
